import { Stack } from 'braid-design-system';
import React from 'react';

import { NotificationsSettingTask } from 'src/app/views/components/NotificationsSetting/components/NotificationsSettingTask';

interface Props {
  jobId?: string;
}
export const NotificationSettingsPanel = ({ jobId }: Props) =>
  jobId ? (
    <Stack space="medium">
      <NotificationsSettingTask jobId={jobId} />
    </Stack>
  ) : null;
